import { lazy, ReactNode, FormEvent } from 'react';
import { Suspense } from '@app/components/Suspense';
import activateAccount from './activateAccount.hoc';

const loadingMessage = 'Loading Page...';
const Lazy = lazy(() => import('./Page'));
const Page = (props: any): JSX.Element => <Suspense loaderMessage={loadingMessage} component={<Lazy {...props} />} />;

export default activateAccount(Page);

export interface SetNewPasswordProps {
  isLoading: boolean;
  controllers: ReactNode;
  t: (text: string) => string;
  handleOnSubmit: (ev: FormEvent) => void;
}
